import leftIcon from '../../static/icons/arrow_left.svg';

type Properties = {
    onClick: () => void;
};

const TopBarBackButton = (props: Properties) => {
    return (
        <img className="icon-button" src={leftIcon} onClick={props.onClick} />
    );
};

export default TopBarBackButton;
